module.exports = __webpack_public_path__ + "static/media/Asset 9.1@3x.8798debc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Avatar/Asset 9.1@3x.png
// module id = 2404
// module chunks = 0